export const S2WP_PLAKATE = [
    {
        header: 'Die Kanone',
        pageId: 135648,
        width: 304,
        height: 447,
        description: 'ersion 1906 von Visual Library haben wir die Möglichkeit implementiert, Autographen nach dem Standard der',
        category: 'Fundstücke',
        crop: '103%'
    },
    {
        header: 'Die Karte',
        pageId: 110795,
        width: 304,
        height: 193,
        description: 'Mit der aktuellen Version 1906ersion 1906 von Visual Library haben wir die Möglichkeit implementiert, Autographen nach dem Standard derr Text Encoding Initiative (TEI) zu erschließen. Sie finden hier ausgewählte Beispiele, die die Möglichkeiten der Erschließung verdeutlichen. Machen Sie Ihre Bestände sichtbar!',
        category: 'Fundstücke',
        crop: '106%'
    },
    {
        header: 'Die Karte',
        pageId: 432785,
        width: 300,
        height: 475,
        description: 'ersion 1906 von Visual Library haben wir die Möglichkeit implementiert, Autographen nach dem Standard der ersion 1906 von Visual Library haben wir die Möglichkeit implementiert, Autographen nach dem Standard der',
        category: 'Fundstücke',
        crop: '116%'
    },
    {
        header: 'Die Karte',
        pageId: 440859,
        width: 300,
        height: 475,
        description: 'ersion 1906 von Visual Library haben wir die Möglichkeit implementiert, Autographen nach dem Standard der ersion 1906 von Visual Library haben wir die Möglichkeit implementiert, Autographen nach dem Standard der',
        category: 'Fundstücke',
        crop: '110%'
    }
];
export const S2WP_DATA = [
    {
        title: 'Festgesang',
        event: 'key',
        date: '1929-06-02',
        pageId: 445480,
        pageHeight: 100,
        pageWidth: 80
    },
    {
        title: 'Festgruß',
        event: 'key',
        date: '1931-12-28',
        pageId: 445479,
        pageHeight: 100,
        pageWidth: 80
    },
    {
        title: 'FRASSLISTE',
        event: 'key',
        date: '1921-02-03',
        pageId: 445478,
        pageHeight: 150,
        pageWidth: 100
    },
    {
        title: 'Halblappenhymne',
        event: 'key',
        date: '1921-02-03',
        pageId: 445476,
        pageHeight: 150,
        pageWidth: 100
    },
    {
        title: 'Jubel- und Festessen der Semilappia in Erinnerung des erstmaligen Erscheinens eines LAPPEN im Kreise der WURZIA vor 50 Jahren',
        event: 'puzzle_outline',
        date: '1930-03-20',
        pageId: 445476,
        pageHeight: 150,
        pageWidth: 100
    },
    {
        title: 'Karte der Glacialablagerungen in der Umgebung von Innsbruck',
        event: 'puzzle_outline',
        date: '1882-01-01',
        pageId: 445261,
        pageHeight: 150,
        pageWidth: 250,
        color: 'blue'
    },
    {
        title: 'Festgedicht auf die Lappenmitglieder',
        event: 'key',
        date: '1920-03-20',
        pageId: 445475,
        pageHeight: 150,
        pageWidth: 100,
        color: 'white'
    },
    {
        title: 'Chronik einer Reise, so vier Musensöhne in das Ötzthal unternommen',
        event: 'key',
        date: '1876',
        pageId: 445461,
        pageHeight: 150,
        pageWidth: 100,
        datatype: 'act',
        color: 'white'
    },
    {
        title: 'Landsleute, Wurzinger und Lappen [Gedichtanfang]',
        event: 'key',
        date: '1909-12-15',
        pageId: 445468,
        pageHeight: 150,
        pageWidth: 100,
        color: 'blue'
    },
    {
        title: 'Landsleute, Wurzinger und Lappen [Gedichtanfang]',
        event: 'key',
        date: '1909-12-15',
        pageId: 445468,
        pageHeight: 150,
        pageWidth: 100,
        color: 'white'
    },
    {
        title: 'Landsleute, Wurzinger und Lappen [Gedichtanfang]',
        event: 'key',
        date: '1909-12-31',
        pageId: 445468,
        pageHeight: 150,
        pageWidth: 100,
        color: 'white'
    }
];
